import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map, Observable, of, switchMap, tap } from "rxjs";
import { HttpService } from "../services/http.service";
import { RouteReservedPrefix } from "../constants/route-reserved-prefix";
import { ApplicantSitesNav } from "talos-careers-page-library";

@Injectable()
export class CanAccessInterviewsGuard  {
  constructor(
    private httpService: HttpService,
    private routerService: Router
  ) { }
  canActivate(): Observable<boolean> {
    return this.httpService.applicantSitesNav$.pipe(
      switchMap(siteNav => siteNav == null ? this.httpService.getSiteNavDetails() : of(siteNav)))
      .pipe(
        map((siteNav: ApplicantSitesNav & {hasReferencing: boolean , hasInterviews: boolean}) => (siteNav && siteNav.hasInterviews) || false),
        tap(canAccess => {
          if (!canAccess) {
            this.routerService.navigate([RouteReservedPrefix.INVALID]);
          }
        })
      );
  }
}